import { type FC, type ReactNode } from 'react';

import styles from './Layout.css';

interface ILayoutProps {
  filters: ReactNode;
  content: ReactNode;
  toTopButton: ReactNode;
  footer: ReactNode;
}

export const Layout: FC<ILayoutProps> = ({ filters, content, toTopButton, footer }) => {
  return (
    <main className={styles['layout']}>
      {filters}
      {content}
      {toTopButton}
      {footer}
    </main>
  );
};
